import { useSite } from "./site-data";
import { PartnersStripView } from "./PartnersStripView";

export function PartnersStrip() {
  const { tiers, partners } = useSite();

  return <PartnersStripView tiers={tiers} partners={partners} />;
}
